// Dependencies
import Glide from '@glidejs/glide';

import { type App } from '~/app';

import './multi-image-inner-carousel.scss'


export default (app: App) => {
    app.logger.debug('[Stockland FE] Initialise Stockland Multi Image Inner Carousel Component');

    const listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]> = [];

    app.afterMount
        .then(() => {
            setTimeout(() => {
                mountMultiImageInnerCarousel(listeners);
            } , 300);

        })
        .catch((error: ErrorOptions | undefined) => {
            throw new Error('[Stockland FE] Unable to register Stockland Multi Image Inner Carousel Component', error);
        });

    return function destroyMultiImageInnerCarousel() {
        unMountMultiImageInnerCarousel(listeners);
        app.logger.debug('[DXA] Feature Links and Image component destroyed');
    };

    function mountMultiImageInnerCarousel(
        listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>,
        root: HTMLElement | null = null
    ) {
        let rootNode: Document | HTMLElement = document;
        if (root) rootNode = root;

        const carousels = rootNode.querySelectorAll('.multi-image-inner-carousel');

        const config = {
            type: 'slider',
            perView: 1.8,
            focusAt: 0,
            startAt: 0,
            gap: 24,
            peek: {
                before: 0,
                after: 0
            }
            ,
            breakpoints:{
                // eslint-disable-next-line @typescript-eslint/naming-convention
                641: {
                    perView: 1.4,
                    focusAt: 0,
                    gap: 8,
                    peek: {
                        before: 0,
                        after: 0
                    }
                },
            }

        }

        const debounce = (func:any, wait:any) => {
            let timeout: NodeJS.Timeout;
            return () => {
                // @ts-expect-error this is dependant on how the function is called
                const context = this;
                const args = arguments;
                const later = function() {
                    func.apply(context, args);
                };

                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
            };
        }

        carousels.forEach((carousel: Element) => {
            try {
                // @ts-expect-error Types of property 'type' are incompatible.
                const multiImageInnerCarouselGlide = new Glide(carousel as HTMLElement, config);

                multiImageInnerCarouselGlide.on(['mount.after', 'run.after', 'update'], function() {
                    setTimeout(() => {
                        setCounterPosition(carousel, multiImageInnerCarouselGlide.index);
                    }, 0);
                });


                multiImageInnerCarouselGlide.mount();

                const handleRefresh = debounce(function() {
                    if (multiImageInnerCarouselGlide){
                        multiImageInnerCarouselGlide.update()
                    }
                }, 250);

                window.addEventListener('resize', handleRefresh);

                listeners.push([window, 'resize', handleRefresh]);

                const button = document.querySelectorAll(".nav-link")

                for (const tabButton of button) {
                    tabButton.addEventListener('click', handleRefresh)
                    listeners.push([tabButton, 'click', handleRefresh])
                }


            } catch {
                console.info("Multi Image Inner Carousels does not exist, not mounting");
            }
        });
    }


    function setCounterPosition(carousel: any, currentIndex: any) {
        const counter = carousel.parentElement?.querySelector('.slide-counter');

        if (counter) {
            const firstSlide = carousel.querySelector('.multi-image-inner-carousel .glide__slide[data-index="0"]');
            const currentSlide = carousel.querySelector('.multi-image-inner-carousel .glide__slide.glide__slide--active');


            if (firstSlide && currentSlide) {
                const slideWidth = currentSlide.offsetWidth;
                const currentSlideRect = currentSlide.getBoundingClientRect();

                const leftPosition = currentSlideRect.left + (slideWidth / 3);

                counter.style.marginLeft = (leftPosition ) + 'px';
                counter.style.marginTop = `30px`;

                counter.querySelector('.current-slide').textContent = currentIndex + 1;
            }
        }
    }

    function unMountMultiImageInnerCarousel(
        listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>
    ) {
        for (const [element, event, listener] of listeners) {
            element.removeEventListener(event, listener);
        }
    }
}
